export enum AlgoliaQueryId {
    Search = 'search',
    SearchTrends = 'search-trends',
    BestSellingProducts = 'best-selling-products',
    LastSeenProducts = 'last-seen-products',
}
